<template>
	<iframe src="https://yandex.ru/map-widget/v1/?um=constructor%3Ac202d39c10dcf0cd522039d059b6db5c759363407110ec14977d75435ee9049a&amp;source=constructor" width="100%" height="300" frameborder="0"></iframe>
</template>

<script>
    export default {
        name: "Contacts"
    }
</script>

<style scoped>

</style>